/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPoliciesCreate } from "../funcs/riskPoliciesCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskPolicy } from "../models/components/riskpolicy.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateRiskPolicyRequest,
  CreateRiskPolicySecurity,
} from "../models/operations/createriskpolicy.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskCreatePolicyMutationVariables = {
  request: CreateRiskPolicyRequest;
  security?: CreateRiskPolicySecurity | undefined;
  options?: RequestOptions;
};

export type RiskCreatePolicyMutationData = RiskPolicy;

export type RiskCreatePolicyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createRiskPolicy risk
 *
 * @remarks
 * Create a new risk analysis policy for the current project.
 */
export function useRiskCreatePolicyMutation(
  options?: MutationHookOptions<
    RiskCreatePolicyMutationData,
    RiskCreatePolicyMutationError,
    RiskCreatePolicyMutationVariables
  >,
): UseMutationResult<
  RiskCreatePolicyMutationData,
  RiskCreatePolicyMutationError,
  RiskCreatePolicyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskCreatePolicyMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskCreatePolicy(): MutationKey {
  return ["@gram/client", "policies", "create"];
}

export function buildRiskCreatePolicyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskCreatePolicyMutationVariables,
  ) => Promise<RiskCreatePolicyMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskCreatePolicy(),
    mutationFn: function riskCreatePolicyMutationFn({
      request,
      security,
      options,
    }): Promise<RiskCreatePolicyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskPoliciesCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
